/**
 * Archies Gender Preference
 *
 * On gendered collections (title contains "mens"/"womens"):
 *   → caches gender to localStorage using the same key as tabs-ext.js
 *
 * On gender-neutral collections:
 *   → reads cached preference and swaps the hover (second) slide image
 *     on each product card to match the customer's preferred gender imagery
 *
 * PDP tab pre-toggling is already handled by tabs-ext.js, which reads
 * the same localStorage key ("collection-type").
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'collection-type';
  const MENS_VALUE  = 'type-men-collection';
  const WOMENS_VALUE = 'type-women-collection';

  function getPreference() {
    const val = localStorage.getItem(STORAGE_KEY);
    if (val === MENS_VALUE)   return 'mens';
    if (val === WOMENS_VALUE) return 'womens';
    // Cold-start fallback: theme default (settings.default_gender_view), emitted
    // as a global by custom-scripts.liquid. Completes the gender cascade:
    // explicit (cache) -> collection seed (Liquid) -> theme default (here).
    const themeDefault = window.ARCHIES_DEFAULT_GENDER;
    if (themeDefault === 'mens' || themeDefault === 'womens') return themeDefault;
    return null;
  }

  function init() {
    const cards = document.querySelectorAll(
      '.card-gallery[data-hover-men-url], .card-gallery[data-hover-women-url]'
    );
    if (!cards.length) return;

    // All cards on a collection page share the same gender, so read from the first one found
    let collectionGender = null;
    for (const card of cards) {
      const cg = card.getAttribute('data-collection-gender');
      if (cg) { collectionGender = cg; break; }
    }

    // Cache gender when browsing a gendered collection
    if (collectionGender === 'mens') {
      localStorage.setItem(STORAGE_KEY, MENS_VALUE);
    } else if (collectionGender === 'womens') {
      localStorage.setItem(STORAGE_KEY, WOMENS_VALUE);
    }

    // On gender-neutral collections, swap hover images to match cached preference
    if (collectionGender) return; // gendered collection — Liquid already served the right image

    const preference = getPreference();
    if (!preference) return;

    cards.forEach(card => {
      const url = preference === 'mens'
        ? card.getAttribute('data-hover-men-url')
        : card.getAttribute('data-hover-women-url');
      if (!url) return;

      // Hover image lives in the second slideshow-slide inside this card
      const slides = card.querySelectorAll('slideshow-slide');
      const hoverSlide = slides[1];
      if (!hoverSlide) return;

      const img = hoverSlide.querySelector('img');
      if (!img) return;

      // Swap src; remove srcset so the browser uses our URL at the resolved width
      img.src = url;
      img.removeAttribute('srcset');
      img.sizes = '800px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
